import React from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';

const ClientTable = ({ clients, handleEdit, handleToggleStatus, onClientSelected }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="min-w-full bg-white table-auto rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr>
            <th className="p-2">Code</th>
            <th className="p-2">Name</th>
            <th className="p-2">Contact</th>
            <th className="p-2">Email</th>
            <th className="p-2">Locations</th>
            <th className="p-2">Status</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {clients.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center text-gray-500 py-10">
                No clients found. Add one to get started.
              </td>
            </tr>
          ) : (
            <>
              {clients.map((client, idx) => (
                <tr key={idx} className="border-t">
                  <td className="p-2 text-[#E91C24] font-bold">
                    <div className="cursor-pointer" onClick={() => onClientSelected(client)}>
                      {u(client.client_code)}
                    </div>
                  </td>
                  <td className="p-2">{u(client.name)}</td>
                  <td className="p-2">{client.phone}</td>
                  <td className="p-2">{u(client.email)}</td>
                  <td className="p-2 whitespace-pre-line">
                    {client.locations?.length || 0}
                  </td>
                  <td
                    className={`p-2 cursor-pointer hover:underline ${
                      client?.is_active ? 'text-green-600' : 'text-red-500'
                    } font-medium`}
                    onClick={() => handleToggleStatus(client)}
                  >
                    {client?.is_active ? 'ACTIVE' : 'INACTIVE'}
                  </td>
                  <td className="p-2">
                    <button onClick={() => handleEdit(client)}>
                      <PencilSquareIcon className="h-5 w-5 text-blue-600 hover:text-blue-800" />
                    </button>
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ClientTable;
